import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { HeadlineTextLarge, TitleTextLarge } from 'Packages/FacetDesign/Components';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly, { ordinal: 200 })
  .nameOverride(['originAccountName', 'destinationAccountName', 'originAccountNumber', 'destinationAccountNumber', 'secondaryDestinationAccountNumber'], {
    _component: () => TitleTextLarge,
  }, overrideReadOnly);
